import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const cryptoApiHeaders = {
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': '4f5dfa972cmshcb6ce13b08bd807p15ab36jsnd23beb34c308'
} 
/* 
const cryptoApiHeaders = {
'x-access-token': 'coinranking1779418fb28a9755be85680eff6343616ce99e522bff698b'
} */

const baseUrl = "https://coinranking1.p.rapidapi.com"


const createRequest = url => ({url, headers: cryptoApiHeaders})

export const cryptoApi = createApi({
    reducerPath: 'cryptoApi',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({
        getCryptos: builder.query({
            query: (count) => createRequest('/coins?limit=' + count)
        }),
        getCryptoDetails: builder.query({
            query: (coinId) => createRequest('/coin/' + coinId)
        }),
        getCryptoHistory: builder.query({
            query: ({coinId, timePeriod}) => createRequest('/coin/' + coinId + "?timePeriod=" + timePeriod)
        }),
        getCryptoExchanges: builder.query({
            query: () => createRequest('/exchanges')
        })

    })
})

export const {
    useGetCryptosQuery, 
    useGetCryptoDetailsQuery, 
    useGetCryptoHistoryQuery,
    useGetCryptoExchangesQuery
} = cryptoApi;










/* var options = {
    method: 'GET',
    url: 'https://coinranking1.p.rapidapi.com/stats',
    headers: {
      'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
      'x-rapidapi-key': '4f5dfa972cmshcb6ce13b08bd807p15ab36jsnd23beb34c308'
    }
  };
   */












